import React from "react";

import icon1 from "./img/icon-service-1.png";
import icon2 from "./img/icon-service-2.png";
import icon3 from "./img/icon-service-3.png";
import icon4 from "./img/icon-service-4.png";
import icon5 from "./img/icon-service-5.png";
import icon6 from "./img/icon-service-6.png";
import icon7 from "./img/icon-service-7.png";
import icon8 from "./img/icon-service-8.png";

import service1 from "./img/service-1.png";
import service2 from "./img/service-2.png";
import service3 from "./img/service-3.png";
import service4 from "./img/service-4.png";

const services = [
  { id: 1, title: "Web Design", img: icon1,des:'We create modern, responsive, and user-friendly website designs that enhance user experience and reflect your brand identity effectively.'},
  { id: 2, title: "Development", img: icon2 ,des:'We provide custom software and web development solutions using the latest technologies to build scalable and high-performance applications.'},
  { id: 3, title: "UI Design", img: icon3,des:'Our UI design focuses on clean layouts, intuitive navigation, and visually appealing interfaces to improve user engagement.' },
  { id: 4, title: "Programming", img: icon4,des:'We offer programming solutions and development services in various languages to build efficient and reliable applications.' },
  { id: 5, title: "Graphic Design", img: icon5,des:'We design creative graphics including logos, banners, and branding materials to make your business stand out.' },
  { id: 6, title: "Video Editing", img: icon6 ,des:'We provide professional video editing services for marketing, social media, and promotional content.'},
  { id: 7, title: "SEO", img: icon7 ,des:'Our SEO services help improve your website ranking on search engines, increasing visibility and organic traffic.'},
  { id: 8, title: "Online Marketing", img: icon8 ,des:'We offer digital marketing solutions including social media marketing and paid ads to grow your business online.'},
];

const serviceRows = [
  {
    id: 1,
    title: "Web Design",
    img: service1,
    reverse: false,
    description:' Dreamworth aim to Provide the best professinal & Affordable Web development solution. We do provide solution for all web development solution, including website development, E-Commerce web design etc...',
  },
  {
    id: 2,
    title: "E-commerce",
    img: service2,
    reverse: true,
    description:'E-commerce solutions are the products and services that help a company conduct business electronically. The range of available e-commerce solutions is vast, including those that allow traditional businesses to design, create, and operate World Wide Web sites',
  },
  {
    id: 3,
    title: "Apps Development",
    img: service3,
    reverse: false,
    description:'Using solid expertise in mobile apps development, our team will help you create practical and seamless experiences on any device and get the best of mobile technology for your business.',
  },
  {
    id: 4,
    title: "Software Development",
    img: service4,
    reverse: true,
    description:' We provide cutting-edge custom software development services to help make business operations more efficient.',
  },
];

function Services() {
  return (
    <div>
        <div class="page-header">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2>Our Services</h2>
                              <h5 style={{'color':'white'}}>“We provide services to help make business operations more efficient.”</h5>
                        </div>
                       
                    </div>
                </div>
            </div>

      {/* Services Grid */}
      <div className="service">
        <div className="container-fluid">

          

          <div className="row">
            {services.map((item) => (
              <div key={item.id} className="col-lg-3 col-md-6">
                <div className="service-item">
                  <h3>{item.title}</h3>
                  <img src={item.img} alt="Service" />
                  <p>{item.des}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* Service Rows */}
      {serviceRows.map((row) => (
        <div key={row.id} className="service-row">
          <div className="container">
            <div className="row align-items-center">

              {/* Image Left */}
              {!row.reverse && (
                <div className="col-md-6">
                  <div className="service-row-img">
                    <img src={row.img} alt="Service" />
                  </div>
                </div>
              )}

              {/* Text */}
              <div className="col-md-6">
                <div className="service-row-text">
                  <h2 className="section-title">{row.title}</h2>
                  <p>
                    {row.description}
                  </p>
                  <button className="btn">Read More</button>
                </div>
              </div>

              {/* Image Right */}
              {row.reverse && (
                <div className="col-md-6">
                  <div className="service-row-img">
                    <img src={row.img} alt="Service" />
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      ))}

    </div>
  );
}

export default Services;